import { isoZ, z } from 'my-zod'

const workOrderTypeOptions = [
  'DamageRepair',
  'PreventativeMaintenance',
  'Quarantined',
  'RecallOrBulletinStopRide',
  'RecallOrBulletinContinuedRental',
  'Service1000Miles',
  'OilChange',
  'AirFilter',
  'TireRotationOrReplacement',
  'BeltReplacement',
  'InactiveReadyForDisposition',
  'AccidentDamage',
  'MachineBreakIn',
  'MechanicalFailure',
  'CheckEngineLight'
] as const

export const workOrderTypeOptionEnum = z.enum(workOrderTypeOptions)

export const WorkTypeOptions = Object.keys(workOrderTypeOptionEnum.Values) as (keyof typeof workOrderTypeOptionEnum.Values)[]

export type WorkTypeOptions = (typeof WorkTypeOptions)[number]

const workOrderAttachment = z.object({
  url: z.string(),
  name: z.string()
})

export const workOrderModel = z.object({
  id: z.string(),
  shortId: z.string(),
  vehicleId: z.number(),
  operatorId: z.number(),
  operatorUnitNumber: z.string().nullable().setLabel('Vehicle Unit Number'),
  vin: z.string().nullable(),
  lastModifiedDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable(),
  createdDate: isoZ.instant(),
  closedDate: isoZ.instant().nullable(),
  operatorWorkOrderId: z.string().nullable(),
  engineHours: z.number().nullable(),
  isClosed: z.boolean(),
  isSafetyIssue: z.boolean(),
  mileage: z.number().nullable(),
  workToBeDone: z.string().nullable(),
  notes: z.string().nullable(),
  workType: workOrderTypeOptionEnum.nullable(),
  images: z.string().array().max(20, 'You have reached the image limit for your work order.'),
  closedImages: z.string().array().max(20, 'You have reached the image limit for your work order.'),
  attachments: workOrderAttachment.array(),
  completedBy: z.string().nullable(),
  estimatedCompletionDate: isoZ.date().nullable(),
  estimatedWorkHours: z.number().int().nonnegative('Must be a positive number').nullable(),
  serviceTaskIds: z.number().array(), // Only used for transport, doesn't live on the workOrder table
  completedServiceTaskIds: z.number().array(), // Only used for transport, doesn't live on the workOrder table
  closedMileage: z.number().nullable(),
  closedEngineHours: z.number().nullable(),
  closedWorkHours: z.number().int().nonnegative('Must be a positive number').nullable()
})

export type workOrderModel = z.infer<typeof workOrderModel>
